import styled from "styled-components";

export const Loader = styled.div`
width: 100%;
height: calc(100vh - 120px);
display: flex;
align-items: center;
justify-content: center;
`;

export const RootContainer =styled.div`
padding: 24px 16px;
`;

export const Title = styled.div`
padding-bottom: 18px;
font-size: 18px;
font-weight: bold;
color: #71207C;
text-align: center;
`;

export const Top = styled.div`
padding-bottom: 24px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
grid-gap: 8px;

font-size: 16px;
font-weight: 500;
color: #000000;
text-align: center;
`;

export const Image = styled.img.attrs({
    alt: 'icon',
})`
width: 85px;
aspect-ratio: 1;
object-fit: cover;
border-radius: 20px;
`;
